import React from 'react';
import styles from './MoonshotBackground.less';

const wave = require('resources/images/moonshot/wave.svg');
const circle = require('resources/images/moonshot/circle.svg');

export const MoonshotBackground = () => (
  <div className={styles.background}>
    <img alt="" className={styles.rightLarge} src={circle} />
    <img alt="" className={styles.rightSmall} src={circle} />
    <img alt="" className={styles.leftLarge} src={circle} />
    <img alt="" className={styles.leftSmall} src={circle} />
    <img alt="" className={styles.wave} src={wave} />
  </div>
);
